import { BookingPassengerDetail } from "@/redux/slices/clientBooking/types";
import { SummaryCard } from "./SummaryCard";
import { TripDetailsBody } from "./TripDetailsBody";

interface TripDetailsSummaryCardProps {
  /** Other Details (DEV-446) — mirrored here so the Payment step shows what was entered. */
  bookedBy?: string;
  reference?: string;
  additionalInfo?: string;
  passengers?: BookingPassengerDetail[];
  /** Names of the attachments picked in Other Details (uploaded after Book Trip). */
  attachments?: string[];
  onEdit?: () => void;
  /** Purple "active" tint — the step currently being viewed/edited. */
  highlighted?: boolean;
  className?: string;
}

/**
 * Trip Details card of the priced Booking Summary. Body is the shared `TripDetailsBody` (same as the
 * draft-step summary), so both variants read identically and can't drift.
 */
export const TripDetailsSummaryCard = ({
  bookedBy,
  reference,
  additionalInfo,
  passengers,
  attachments,
  onEdit,
  highlighted,
  className,
}: TripDetailsSummaryCardProps) => (
  <SummaryCard icon="User" title="Trip Details" onEdit={onEdit} highlighted={highlighted} className={className}>
    <TripDetailsBody
      bookedBy={bookedBy}
      reference={reference}
      additionalInfo={additionalInfo}
      attachmentNames={attachments}
      passengers={passengers}
      highlighted={highlighted}
    />
  </SummaryCard>
);
